/* eslint-disable @typescript-eslint/no-explicit-any */
export const filterBySearchText =
  <T extends { [key: string]: any }>(data: T[]) =>
  (searchText: string): T[] => {
    const search = searchText.toLowerCase()
    return data.filter((item) => {
      return Object.entries(item).some(([_, value]) => {
        const text = (value || '').toString().toLowerCase()
        return text.includes(search)
      })
    })
  }
